$(() => {
  const $target = $('#js-stripe-3d-secure');
  if (!$target.length) return;

  const clientSecret = $target.data('secret');        // PaymentIntentのclient_secret
  const publicKey = $target.data('public-key'); // StripeのPublishable Key
  const stripe = Stripe(publicKey);

  // 3Dセキュア認証の必要があるかチェックして処理
  stripe.confirmCardPayment(clientSecret).then(result => {
    if (result.error) {
      // 認証失敗・キャンセルなど
      alert(result.error.message);
      $('#js-stripe-3d-secure_back').click()
    } else {
      // 認証成功・決済完了
      $('#js-stripe-3d-secure_payment_intent_id').val(result.paymentIntent.id)
      $('#js-stripe-3d-secure_submit').click()
    }
  });
});
